import React from 'react';
import Logo from '../Logo';

const AuthHero = () => {
  return (
    <div className="hidden lg:flex lg:w-1/3 bg-gradient-to-br from-blue-600 to-blue-700 relative overflow-hidden">
      <div className="absolute left-24 bottom-0 opacity-40 w-[600px] h-[600px] z-0">
        <Logo width="100%" height="100%" logoFill="#6b21a8" mobile={true} />
      </div>
      <div className="flex flex-col justify-end items-center pb-0 pt-12 px-12 relative z-10 w-full h-full">
        <div className="flex-1 flex flex-col justify-center items-center">
          <h1 className="!text-white text-4xl font-bold font-['Montserrat'] text-center mb-4">
            Stop missing calls. Start booking jobs.
          </h1>
          <p className="!text-white text-lg font-medium font-['Inter'] text-center">
            The only AI receptionist that talks, texts, and takes deposits simultaneously. It handles the full booking lifecycle so you can stay focused on the work.
          </p>
        </div>
        <div className="relative w-full max-w-lg mb-0">
          <img
            className="w-full h-auto relative z-10"
            src="/assets/virtual_assistant.png"
            alt="Virtual Assistant"
          />
        </div>
      </div>
    </div>
  );
};

export default AuthHero;
